import { api_get, api_post } from "./utils"

const BioAPI = {
    load: _loadBio,
    list: _loadBioList,
    create: _createBio,
};


async function _loadBio(key: string) {
    // Autogenerated
    if (!key) {
        return null;
    }
    return api_get("/bio/" + key).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _loadBioList(identityKey : "", cursor: string) {
    // Autogenerated
    let url = '/bio/list?';
    if(identityKey) {
        url += 'identityKey=' + identityKey + '&';
    }
    if (cursor) { url += 'cursor=' + cursor; }
    return api_get(url).then((res) => {
        if (!res.ok) {
            return null;
        }
        else {
            return res.json();
        }
    });
}


async function _createBio() {
    // Autogenerated
    return api_post('/bio/create',
        {
        })
        .then(async (res) => {
            if (res.ok) {
                return await res.json();
            }
        });
}

export default BioAPI;
